import CreateAiAssessmentScaleView from "@features/tools/view/ai-assessment-scale/create-ai-assessment-scale";

const CreateAiAssessmentScale = () => {
  return <CreateAiAssessmentScaleView />;
};

export default CreateAiAssessmentScale;
